import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { GenericPersonDataDTO, Patient, PatientApiService } from '../../../api/patient';
import { UserApiService } from '../../../api/user';
import { PatientConsultationApiService } from '@api/patient/consultation';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { EvaluationConfig } from '@app/features/patient/consultation/new/evaluation/evaluation.component';

@Component({
  selector: 'medico-fecha',
  templateUrl: './medico-fecha.component.html',
  styleUrls: ['./medico-fecha.component.scss'],
})
export class MedicoFechaComponent implements OnInit {
  @Input() fromMedicalConsultation?:boolean;
  @Input() config: EvaluationConfig;
  @Input() profesionalId?: number;
  @Output() dateChange = new EventEmitter<string>(); // Definir el @Output

  profesional?: number;
  nutricionist$: Observable<GenericPersonDataDTO[]>;
  institutoId: string;
  profesionalName: string;
  date: Date = new Date();
  disabledDates: boolean = true;
  form: FormGroup;
  patientId: number;
  evaluationDates: Date[] = [];

  constructor(
    private fb: FormBuilder,
    private userApi: UserApiService,
    private patientService: PatientApiService,
    private patientConsultationApiService: PatientConsultationApiService,
    private route: ActivatedRoute,
  ) {
    const user = this.userApi.getUser();
    this.profesional = Number(user.id_person);
  }

  ngOnInit(): void {
    this.getInstituteId();
    this.getNutricionist();
    this.getPatients();
    this.getEvalutions(this.patientId);
    this.form = this.fb.group({
      date: new FormControl(),
      profesionalName: new FormControl(''), // Agregar FormControl para el nombre del profesional
    });

    this.form.get('date').valueChanges.subscribe(value => {
      this.emitDateChange(value);
    });

    if(this.fromMedicalConsultation) {
      this.form.get('date').setValidators([Validators.required])
    }

    let user = this.userApi.getUser();
    this.initializeFilterFn();
  }

  getPatients() {
    this.route.params.subscribe((params) => {
      if(params.type) {
        this.disabledDates = false;
      }
      if(params.patientId || params.id) {
        this.patientId = Number(params.patientId) || Number(params.id);
        this.getEvalutions(this.patientId);
      }
    });
  }


  emitDateChange(value: any) {
    const date = new Date(value);
    const now = new Date();
    date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    this.dateChange.emit(formattedDate); // Emitir el valor de la fecha actual con formato yyyy-MM-dd HH:mm
  }

  initializeFilterFn() {
    this.filterFn = (date: Date): boolean => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Establecer la hora a 00:00:00 para comparar solo la fecha
      return !this.evaluationDates.some(evaluationDate =>
        evaluationDate.getFullYear() === date.getFullYear() &&
        evaluationDate.getMonth() === date.getMonth() &&
        evaluationDate.getDate() === date.getDate()
      ) && date < today; // Asegurarse de que la fecha sea menor que hoy
    };
  }

  filterFn: (date: Date) => boolean;

  getNutricionist() {
      this.patientService.getNutricionist(Number(this.institutoId)).subscribe((data) => {
        this.nutricionist$ = of(data.genericPersonDataDTOList);
        let dataNutricionist = data.genericPersonDataDTOList.find((nutricionist) =>
          nutricionist.id == (this.profesionalId ?? this.profesional)
        );
        this.form.get('profesionalName').setValue(dataNutricionist);
      });
  }

  getInstituteId() {
    this.institutoId = this.userApi.getUser().instituteId;
  }

  getEvalutions(patientId: number, fechaDesde?: string, fechaHasta?: string) {
    this.patientConsultationApiService.getPeriodConsultation(patientId, fechaDesde, fechaHasta, 0, 1).subscribe((consultations) => {
      this.evaluationDates = consultations.map(consultation => new Date(consultation.creationDate));
      this.initializeFilterFn();
    });
  }
}
